import ISO6391 from "iso-639-1";

export interface LanguageOption {
  value: string;
  label: string;
}

// Get all languages with their native names
const allLanguages = ISO6391.getAllNames().map((name) => {
  const code = ISO6391.getCode(name);
  return {
    value: code.toUpperCase(),
    label: name,
  };
});

// Sort alphabetically by label
const sortedLanguages: LanguageOption[] = allLanguages.sort((a, b) =>
  a.label.localeCompare(b.label)
);

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: "ANY", label: "Any" },
  ...sortedLanguages,
];

export const getLanguageLabel = (
  code?: string | null,
  t?: (key: string, fallback: string) => string
): string => {
  if (!code) return "-";
  if (code === "ANY") return t ? t("common.any", "Any") : "Any";

  // Handle multiple comma-separated codes
  const codes = code.split(",").map((c) => c.trim().toLowerCase());
  const labels = codes.map((c) => {
    if (c === "any") return t ? t("common.any", "Any") : "Any";
    const name = ISO6391.getName(c);
    return name || c.toUpperCase();
  });

  return labels.join(", ");
};
